import qs from 'qs';

function _decode (str: string): string {
  return str.replace(/\+/g, '%20');
}

function _encode (str: any): string {
  if (str.length === 0) {
    return str;
  }

  let string = str;
  if (typeof str === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }

  return string.replace(' ', '%20');
}

function stringify (params: {[key: string]: any}, addQueryPrefix: boolean = true): string {
  if (addQueryPrefix) {
    const result: string = qs.stringify(params, { addQueryPrefix: true, encoder: _encode });
    return result === '?' ? '' : result;
  }
  return qs.stringify(params, { addQueryPrefix: false, encoder: _encode });
}

function parse (paramsString: string): any {
  return qs.parse(paramsString, { ignoreQueryPrefix: true, decoder: _decode });
}

const UrlQuery = {
  stringify,
  parse
};

export default UrlQuery;
